import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const AgenticAwarenessModalHost: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgenticAwarenessModalHost" */
				'../src/host/AgenticAwarenessModalHost.tsx'
			)
		).AgenticAwarenessModalHost,
});
